import { render, staticRenderFns } from "./MoreThan24Hours.vue?vue&type=template&id=30bc914b&scoped=true&"
import script from "./MoreThan24Hours.vue?vue&type=script&lang=js&"
export * from "./MoreThan24Hours.vue?vue&type=script&lang=js&"
import style0 from "./MoreThan24Hours.vue?vue&type=style&index=0&id=30bc914b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bc914b",
  null
  
)

export default component.exports